import { WhiteArrowButton } from "@/components/mypage/arrowButton";
import { cn } from "@roman/shared/utils";

export interface RedeemOptionProps {
  icon: string;
  title: string;
  buttonText: string;
  disabled?: boolean;
  onClick: () => void;
  isDisplayLabel?: boolean;
  labelContent?: JSX.Element;
}

export const RedeemOption = ({
  icon,
  title,
  buttonText,
  disabled,
  onClick,
  isDisplayLabel,
  labelContent,
}: RedeemOptionProps) => (
  <div className="w-full mb-4 relative">
    <div className="bg-white rounded-lg p-4 shadow-sm h-full flex flex-col justify-between">
      <div className="flex items-center gap-4 ml-2 mb-2">
        <img src={icon} alt={title} className="w-24 h-24" />
        <div className="ml-4 flex-1">
          <p className="text-lg font-bold text-dark-gray">{title}</p>
        </div>
      </div>
      <button
        type="button"
        disabled={disabled}
        onClick={onClick}
        className={cn(
          "font-bold px-4 py-2 rounded-md w-full flex items-center justify-center",
          disabled ? "bg-disabled text-white" : "bg-gradient-primary text-white",
        )}
      >
        {buttonText}
        <WhiteArrowButton className="ml-2 rotate-0" />
      </button>
    </div>
    {isDisplayLabel && labelContent}
  </div>
);
